import React from 'react'
import {
  BooleanField,
  Datagrid,
  EmailField,
  TextInput,
  // SearchInput,
  SelectInput,
  useTranslate,
  useStore,
} from 'react-admin'
import { ListBase } from '../../components/base'
import { BranchSelect } from '../../components/app-bar/type'
import { NameField, DateField } from '../../components/fields'
import { COMMON_FIELDS, EMAILCONFIG_FIELDS } from '../../providers/localization/constant'
// import EmptyDataGrid from '../../components/list/EmptyDataGrid'

const EmailConfigListFilters = (): JSX.Element[] => {
  const translate = useTranslate()
  return [
    // <SearchInput
    //   key={0}
    //   source='q'
    //   alwaysOn
    //   InputLabelProps={{ shrink: true }}
    //   InputProps={{ notched: false }}
    //   placeholder={translate(`${EMAILCONFIG_FIELDS}.name`)}
    // />,
    <TextInput key={0} source='title' alwaysOn label={translate(`${EMAILCONFIG_FIELDS}.title`)} />,
    <SelectInput
      key={1}
      label={`${COMMON_FIELDS}.status.label`}
      source='is_active'
      alwaysOn
      choices={[
        { id: 'true', name: `${COMMON_FIELDS}.status.choices.active` },
        { id: 'false', name: `${COMMON_FIELDS}.status.choices.inActive` },
      ]}
    />,
  ]
}

const EmailConfigList = (): JSX.Element => {
  const [globalBranch] = useStore<BranchSelect>('branch.selected')
  // if (globalBranch?.id == null) {
  //   return <EmptyDataGrid />
  // }
  return (
    <ListBase
      // listAction={{
      //   hasExport: false,
      // }}
      filter={{branch_codes: globalBranch?.id}}
      filters={EmailConfigListFilters()}
      sort={{ field: 'create_at', order: 'DESC' }}
    >
      <Datagrid rowClick='edit' bulkActionButtons={false}>
        <NameField
          firstNameSource='first_name'
          lastNameSource='last_name'
          source='first_name'
          label={`${EMAILCONFIG_FIELDS}.name`}
          sortable={false}
        />
        {/* <TextField source='first_name' label={`${EMAILCONFIG_FIELDS}.first_name`} sortable={false}></TextField>
        <TextField source='last_name' label={`${EMAILCONFIG_FIELDS}.last_name`} sortable={false}></TextField> */}
        <EmailField source='email' label={`${EMAILCONFIG_FIELDS}.email`} sortable={false}></EmailField>
        <DateField
          source='create_at'
          showTime
          label={`${COMMON_FIELDS}.date.created_at`}
          textAlign='center'
        />
        {/* <DateField
          source='update_at'
          showTime
          label={`${COMMON_FIELDS}.date.updated_at`}
          textAlign='center'
        /> */}
        <BooleanField
          source='is_active'
          label={`${COMMON_FIELDS}.status.label`}
          textAlign='center'
          sortable={false}
        />
      </Datagrid>
    </ListBase>
  )
}

export default EmailConfigList
